import React from 'react';

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const Templatelist = () => {

  function createData(template,category,preview,quality,languages,lastupdated,action	) {
    return {template,category,preview,quality,languages,lastupdated,action};
  }
  const rows = [
    createData("templatename","testname","","yes","english","6/07/2023", " ",),
    createData("templatename","testname", " ","yes","english","6/07/2023", " ",),
    createData("templatename","testname"," ", "yes","english","6/07/2023", " ",),
    createData("templatename","testname"," " ,  "yes","english","6/07/2023", " ",),
    createData("templatename","testname"," ", "yes","english","6/07/2023", " ",),
    createData("templatename","testname"," ", "yes","english","6/07/2023", " ",),
    createData("templatename","testname"," ", "yes","english","6/07/2023", " ",),
    createData("templatename","testname"," " ,"yes","english", "6/07/2023", " ",),
    
  ];
  return (
    <>
      <div className='content'>
      <Row>
          <Col className="mb-5" md="12">
            <Card>
             
              <CardBody>
              <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table" >
        <TableHead>
          <TableRow>
                    <TableCell >Template </TableCell>
                    <TableCell >Category</TableCell>
                    <TableCell > Preview</TableCell>
                    <TableCell >Quality</TableCell>
                    <TableCell  > Languages</TableCell>           
                    <TableCell  > Last Updated	</TableCell>           
                    <TableCell  > Action</TableCell>           
          </TableRow>
          
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.template}
              </TableCell>
              <TableCell >{row.category}</TableCell>
              <TableCell >{row.preview}</TableCell>
              <TableCell >{row.quality}</TableCell>
              <TableCell >{row.languages}</TableCell>
              <TableCell >{row.lastupdated}</TableCell>
              <TableCell >{row.action}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
              </CardBody>
            </Card>
          </Col>
          
        </Row>
      </div>
    </>
  )
}

export default Templatelist
